<template>
  <thead>
    <TableRow>
      <slot />
    </TableRow>
  </thead>
</template>

<script>
import TableRow from '@/packages/ui/components/TableV2/TableRow.vue';

export default {
  name: 'TableHead',
  components: { TableRow },
};
</script>
